import { PublicClientApplication } from '@azure/msal-browser'
import { useIdentityStore } from '@/stores/identity'

const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
    authority: 'https://qtacpayrollservices.ciamlogin.com/44099b76-5450-4e05-9b5c-4d888737962f',
    knownAuthorities: ['qtacpayrollservices.ciamlogin.com'],
    redirectUri: process.env.VUE_APP_MSAL_REDIRECT_URI,
    postLogoutRedirectUri: process.env.VUE_APP_MSAL_POST_LOGOUT_REDIRECT,
    authorityMetadata: process.env.VUE_APP_MSAL_AUTHORITY_METADATA,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
}

const msalInstance = new PublicClientApplication(msalConfig)

let msalInitialized = false
let redirectHandled = false

export async function initializeMsal() {
  if (!msalInitialized) {
    await msalInstance.initialize()
    msalInitialized = true
  }

  if (!redirectHandled) {
    const redirectResponse = await msalInstance.handleRedirectPromise()

    if (redirectResponse?.account) {
      msalInstance.setActiveAccount(redirectResponse.account)
    } else {
      const existingAccount =
        msalInstance.getActiveAccount() ||
        msalInstance.getAllAccounts()[0] ||
        null

      if (existingAccount) {
        msalInstance.setActiveAccount(existingAccount)
      }
    }

    redirectHandled = true
    return redirectResponse
  }

  return null
}

export async function restoreIdentityFromMsal() {
  const identityStore = useIdentityStore()

  const account =
    msalInstance.getActiveAccount() ||
    msalInstance.getAllAccounts()[0] ||
    null

  if (!account) {
    identityStore.clearUser()
    sessionStorage.removeItem('account-login-auto-redirect-started')
    return null
  }

  msalInstance.setActiveAccount(account)

  try {
    const tokenResponse = await msalInstance.acquireTokenSilent({
      account,
      scopes: ['openid', 'profile', 'email'],
      extraQueryParameters: { p: 'OneTimeCodeLogin' },
    })

    identityStore.setUser(account, tokenResponse.idTokenClaims)
    sessionStorage.removeItem('account-login-auto-redirect-started')
    return account
  } catch (err) {
    console.warn('Failed to restore user from MSAL cache:', err)
    identityStore.clearUser()
    sessionStorage.removeItem('account-login-auto-redirect-started')
    return null
  }
}

export { msalInstance }